import { createFeature, createReducer, on } from "@ngrx/store";
import { AuthState } from "../auth.model";
import { authActions } from "./actions";

export const initialAuthState: AuthState = {
  isLoading: false,
  success: false,
  username: "",
};

const authFeature = createFeature({
  name: "auth",
  reducer: createReducer(
    initialAuthState,
    on(authActions.requestLogin, (state, event) => ({
      ...state,
      isLoading: true,
      username: event.username,
    })),
    on(authActions.requestLoginSuccess, (state, event) => ({
      ...state,
      isLoading: false,
      success: true,
    })),
    on(authActions.requestLogout, (state, event) => ({ ...initialAuthState }))
  ),
});

export const { name: authFeatureKey, reducer: authReducer } = authFeature;
